module.exports = __webpack_public_path__ + "static/media/icon-agep-people.2f5c7e4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/icon-agep-people.svg
// module id = 215
// module chunks = 0